<template>
  <PageLayout>
    <IContainer>
      <div class="_margin-top:8">
        <IRow>
          <IColumn>
            <div class="_text:left _margin-bottom:2">
              <Link
                class="_display:flex _text:primary _text:normal _padding-right:1"
                href="#"
                @click="redirectBack"
                title="Go Back">
                <ChevronLeftIcon
                  class="_display:flex _align-self:center _margin-right:1/2 action-icon" />
                Go Back
              </Link>
            </div>
          </IColumn>
        </IRow>
      </div>
    </IContainer>
    <IContainer>
      <IRow>
        <IColumn xs="12">
          <main>
            <!-- Terms & Policy content-->
            <section>
              <i-container>
                <i-card color="light">
                  <div class="_padding:y _padding-x:2">
                    <i-row middle>
                      <i-column xs="12">
                        <div>
                          <Privacy
                            class="prose prose-lg max-w-none _text:dark-30 _text:lg _padding-y:4" />
                        </div>
                      </i-column>
                    </i-row>
                  </div>
                </i-card>
              </i-container>
            </section>
          </main>
        </IColumn>
      </IRow>
    </IContainer>
  </PageLayout>
</template>

<script setup>
  import { Link } from '@inertiajs/vue3'
  import PageLayout from '@/Layouts/PageLayout.vue'
  import Privacy from '@/Content/Privacy.md'
  import { ChevronLeftIcon } from '@heroicons/vue/24/outline'
  import { useMeta } from '@/Composables/useMeta'

  // use meta for title, description
  useMeta({
    title: 'Privacy Policy',
    description:
      'At Climate64, your privacy is our number one priority. We will do everything in our power to keep you and your data safe.',
  })

  const redirectBack = () => {
    window.history.back()
  }
</script>

<style scoped>
  .action-icon {
    width: 20px;
    height: 20px;
    stroke-width: 0.1em;
  }
</style>
